import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const [showIntroLogo, setShowIntroLogo] = useState(true);
  const [fadeOutIntro, setFadeOutIntro] = useState(false);

  useEffect(() => {
    // Nach 2 Sekunden: Fade-Out starten
    const fadeTimer = setTimeout(() => {
      setFadeOutIntro(true);
      // Nach Fade-Out: Intro komplett entfernen
      setTimeout(() => {
        setShowIntroLogo(false);
      }, 1500);
    }, 2000);

    return () => clearTimeout(fadeTimer);
  }, []);

  // Content erscheint 0.2s nach Fade-Out Start
  const [showMainContent, setShowMainContent] = useState(false);
  useEffect(() => {
    const contentTimer = setTimeout(() => {
      setShowMainContent(true);
    }, 2200); // 2s Intro + 0.2s = 2.2s

    return () => clearTimeout(contentTimer);
  }, []);

  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background YouTube Video */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <iframe
            className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 scale-150"
            src="https://www.youtube.com/embed/DXozj6Ro2pQ?autoplay=1&mute=1&loop=1&playlist=DXozj6Ro2pQ&controls=0&showinfo=0&rel=0&modestbranding=1&start=16&end=180&playsinline=1&enablejsapi=1&disablekb=1&fs=0&iv_load_policy=3"
            title="Background Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ pointerEvents: 'none' }}
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/75 via-gray-900/70 to-gray-900/85"></div>
      </div>

      {/* Intro Logo - Zentriert, 2 Sekunden mit durchscheinendem Video */}
      {showIntroLogo && (
        <div 
          className="fixed inset-0 z-[60] flex items-center justify-center transition-opacity duration-[1500ms] ease-in-out"
          style={{ 
            opacity: fadeOutIntro ? 0 : 1,
            backgroundColor: 'rgba(17, 17, 17, 0.5)',
            pointerEvents: fadeOutIntro ? 'none' : 'auto'
          }}
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_srcglobal-web/artifacts/h90h1gk3_src-global-white.svg" 
            alt="SRC Global" 
            className="w-[300px] md:w-[400px] h-auto drop-shadow-2xl"
            style={{ imageRendering: 'crisp-edges' }}
          />
        </div>
      )}

      {/* Main Content - erscheint 0.2s nach Fade-Out Start */}
      {showMainContent && (
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 animate-fadeIn">
          <div className="text-left">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
              Gestalten Sie
              <span className="block mt-2 text-green-400">Ihren Klimaschutz</span>
            </h1>
            <p className="text-xl sm:text-2xl text-green-300 mb-6 drop-shadow-md font-semibold">
              Wie haben Sie vor, Ihre Klimaziele zu erreichen?
            </p>
            <p className="text-lg sm:text-xl text-white mb-12 drop-shadow-md">
              Wir beraten Unternehmen auf dem Weg zur Optimierung ihrer CO₂-Bilanz und begleiten sie bis zur Klimaneutralität. Das Klimaschutzgesetz bildet die Grundlage für gezielte und massgeschneiderte Lösungen.
            </p>
          </div>
        </div>
      )}

      {/* Scroll-Indikator */}
      {showMainContent && (
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce z-40">
          <ChevronDown className="w-12 h-12 text-white" />
        </div>
      )}
    </section>
  );
};

export default HeroSection;